/**
 * Environment de desenvolvimento.
 *
 * Substituído por `environment.production.ts` em build de produção via
 * `fileReplacements` no `angular.json`.
 *
 * Apenas chaves PÚBLICAS aqui (Sentry DSN, API URL). Secrets do backend
 * NUNCA entram no bundle Angular.
 */
export const environment = {
  production: false,
  apiUrl: 'https://quer-apostar-service.duka.dev',
  graphqlUrl: 'https://quer-apostar-service.duka.dev/graphql',
  graphqlWsUrl: 'wss://quer-apostar-service.duka.dev/graphql',
  sentryDsn: '',
  commitSha: 'local',
  tosVersion: '1.0',
};
